"use client";
import c from "styled-components";
import { capitalizeFirstLetter as d } from "./index.es169.js";
import s from "react";
import F from "./index.es173.js";
import b from "./index.es274.js";
import { toSettings as $ } from "./index.es82.js";
const v = (t, a, l, o) => {
  if (typeof o != "object")
    return "";
  if (t === "primary")
    return "Hovedinndeling";
  if (t === "secondary")
    return "Sekundærinndeling";
  if (t === "filters" && "name" in o)
    return `${o.name}`;
  if (t === "primaryFilter") {
    const n = a.primary.value;
    return `${l?.[n] || d(n)}`;
  }
  if (t === "secondaryFilter") {
    const n = a.secondary.value;
    return `${l?.[n] || d(n)}`;
  }
  return "";
}, h = c.div``, C = c.div``, I = ({
  parentId: t,
  input: a,
  dimensionLabels: l,
  onValueChange: o
}) => {
  const n = (e, i, m) => {
    const r = $(a);
    if (i === "primary" || i === "secondary") {
      const y = String(e);
      if (i === "primary" && r.secondary === y) {
        const g = r.primaryFilter;
        r.primaryFilter = r.secondaryFilter, r.secondaryFilter = g, r.secondary = r.primary;
      }
      r[i] = y;
    }
    i === "filters" && m && (e ? r.filters[m] = String(e) : r.filters[m] && delete r.filters[m]), (i === "primaryFilter" || i === "secondaryFilter") && Array.isArray(e) && (r[i] = e), o(r);
  }, p = (e) => /* @__PURE__ */ s.createElement(
    b,
    {
      key: `${t}-select-${e}-primary-${a.primary.value}`,
      label: v(e, a, l, a[e]),
      input: a[e],
      property: e,
      parentId: t,
      dimensionLabels: l,
      onValueChange: n
    }
  ), f = ["primary", "secondary"], u = [
    "filters",
    "primaryFilter",
    "secondaryFilter"
  ];
  return /* @__PURE__ */ s.createElement(F, null, /* @__PURE__ */ s.createElement(h, { className: "bl-m-b-4 bl-grid bl-grid--three-columns" }, f.map(p)), /* @__PURE__ */ s.createElement(C, { className: "bl-grid bl-grid--three-columns" }, u.map(p)));
};
export {
  I as default
};
//# sourceMappingURL=index.es172.js.map
